<template>
  <div class="select-user-department-component">
    <a-select
        show-search
        option-filter-prop="children"
        style="display: block;"
        :placeholder="placeholder"
        :mode="mode"
        :disabled="disabled"
        :options="departmentOptions"
        :value="value"
        @change="onChange"
    >
    </a-select>
  </div>
</template>

<script>
import userDepartmentApi from "~/api/user_department";

export default {
  name: "SelectUserDepartmentComponent",
  props: {
    value: {
      type: [Array, String, Number],
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "Selecteer..."
    },
    useHashIdProperty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      departments: [],
      loading: true,
      setValue: this.value,
    };
  },
  mounted() {
    this.initDepartments();
  },
  computed: {
    mode() {
      return this.multiple ? "multiple" : "default";
    },
    isValueHashId() {
      return Array.isArray(this.value) ? isNaN(this.value[0]) : isNaN(this.value);
    },
    departmentOptions() {
      return this.departments.map((department) => {
        return {
          label: department.name,
          value: this.getDepartmentValue(department),
        }
      })
    },
  },
  methods: {
    initDepartments() {
      userDepartmentApi.index()
          .then(response => {
            this.departments = response.data;
          })
          .catch(() => {
            this.$notification["error"]({
              message: "Er ging iets mis",
              description: "Het is niet gelukt om de afdelingen te laden",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onChange(department) {
      this.setValue = department;
      this.$emit("change", department);
      this.$emit("input", department);
    },
    getDepartmentValue (department) {
      if (this.useHashIdProperty === false) {
        return department.id;
      }

      return (this.isValueHashId && this.doesOptionHaveHashId(department)) ? department.hashid : department.id;
    },
    doesOptionHaveHashId(option) {
      return Object.hasOwn(option, 'hashid');
    },
  }
};
</script>
